import axios from 'axios'
import store from '@/store'

const service = axios.create({
  baseURL: process.env.VUE_APP_RESTFUL_API,
  // timeout: 50000,
  crossdomain: true
})

// request interceptors
service.interceptors.request.use(config => {
  if (store.state.token) {
    config.headers['Authorization'] = 'Bearer ' + store.state.token
  }
  config.params = {
    // lang: store.state.selectedLanguage,
    ...config.params
  }
  return config
}, error => {
  Promise.reject(error)
})

// response interceptor
service.interceptors.response.use(
  response => {
    // if (response.headers['content-type'].indexOf('application/xml') > -1) {
    //   return response.data
    // }
    // if (!response.data.code) {
    //   return response.data
    // }
    // if (response.data.code !== 200) {
    //   store.commit('NEW_ERROR', {
    //     code: response.data.code,
    //     response: response
    //   })
    //   console.error(`🚨 [API] ${response.config.url.replace(response.config.baseURL, '')}`, response.data)
    // } else {
    //   if (process.env.NODE_ENV === 'development') {
    //     console.debug(`👌 [API] ${response.config.url.replace(response.config.baseURL, '')}`, response.data)
    //   }
    // }
    return response
  },
  error => {
    if (error.response.status === 401) {
      store.commit('CLEAR_USER')
      window.location.reload()
    }
    console.error('🚨 [API ERR] ' + error)
    return Promise.reject(error)
  })

export default service
